import utils from './index';

export default {

  join(value, splitor) {
    return value.join(splitor)
  },

  boolean(value) {
    return utils.boolean(value)
  },

  currency(value) {
    return utils.formatCurrency(value)
  },

  currency4(value) {
    return utils.formatCurrency4(value)
  },

  fromatBr(value) {
    return utils.rawBr(value)
  }
}
